import authInstance from "../utilities/axios/authInstance";

export const allIncidentReports = () => authInstance.get('incident-reports');

